import { render, staticRenderFns } from "./InstructionListContainer.vue?vue&type=template&id=767b655f&scoped=true&"
import script from "./InstructionListContainer.vue?vue&type=script&lang=js&"
export * from "./InstructionListContainer.vue?vue&type=script&lang=js&"
import style0 from "./InstructionListContainer.vue?vue&type=style&index=0&id=767b655f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767b655f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
